<template>
  <div class="choose">
    <nav-bar
      fixed
      z-index="99"
      title="玩家选择"
      left-text="我的游戏"
      @click-left="$router.push('/game/my')"
      right-text="个人中心"
      @click-right="$router.push('/user')"
    />
    <div class="choose-avatar">
      <img class="choose-avatar-img" :src="userInfo.avatar" alt="" />
    </div>
    <div class="choose-step">
      <ChooseStep1 v-if="step == 1" :value.sync="form" />
      <ChooseStep2 v-if="step == 2" :value.sync="form" />
      <ChooseStep3 v-if="step == 3" :value.sync="form" />
      <ChooseStep4 v-if="step == 4" :value.sync="form" />
    </div>
    <div v-if="step == 1 || step == 2">
      <NfButton round=".5rem" @click.native="nextStep">下一步</NfButton>
    </div>

    <div v-if="step == 3">
      <NfButton
        round=".5rem"
        color="rgb(255,122,110)"
        @click.native="userExitGame"
        >退出游戏</NfButton
      >
    </div>

    <div v-if="step == 4">
      <!-- <div class="choose-btn">
        <NfInput
          :value.sync="inviteNumber"
          placeholder="输入玩家手机号邀请进入"
          clearable
        />
        <NfButton round=".5rem" @click.native="inviteHandle" width="40%"
          >邀请玩家</NfButton
        >
      </div> -->
      <div class="choose-btn">
        <NfButton
          round=".5rem"
          color="rgb(255,122,110)"
          @click.native="exitGame"
          >强制结束游戏</NfButton
        >
        <NfButton
          round=".5rem"
          @click.native="nextStep"
          v-if="form.playerList.length > 0"
          >开始游戏</NfButton
        >
      </div>
      <NfButton round=".5rem" @click.native="copyLink">复制游戏链接</NfButton>
    </div>

    <!-- 输入密码弹窗 -->
    <Popup v-model="showPassword" :close-on-click-overlay="false">
      <div class="password">
        <!-- <div class="password-title">请输入密码</div> -->
        <div class="password-input">
          <Field
            v-model="form.password"
            placeholder="请输入当前游戏密码"
            clearable
          />
        </div>
        <div class="password-btn">
          <Button type="primary" block @click="confirmPassword"> 确定 </Button>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
import NfButton from "@/components/game-ui/NfButton.vue";
import NfInput from "@/components/game-ui/NfInput.vue";
import ChooseStep1 from "./components/choose-step-1.vue";
import ChooseStep2 from "./components/choose-step-2.vue";
import ChooseStep3 from "./components/choose-step-3.vue";
import ChooseStep4 from "./components/choose-step-4.vue";
import ws from "@/utils/ws";

import {
  createPlayer,
  getGameInfo,
  getPlayerList,
  modifyGameStatus,
  getRoundConfig,
  exitGame,
  inviteMember,
} from "@/api/game";
import { Popup, Field, Button, NavBar, Notify } from "vant";

export default {
  components: {
    ChooseStep1,
    ChooseStep2,
    ChooseStep3,
    ChooseStep4,
    NfButton,
    Popup,
    Field,
    Button,
    NavBar,
    NfInput,
  },
  // 获取query参数
  async mounted() {
    if (this.$route.query.gameId) {
      // 教练创建
      this.key = this.$route.query.gameId;
      // this.requstWs();
    }

    if (this.$route.query.step) {
      this.step = this.$route.query.step;
    }
    this.userInfo = this.$store.state.app.userInfo;
    await this.getGameInfo();
    this.getGamePlayerList();

    // 如果是教练，直接进入第四阶段等待
    if (this.isCreater) {
      this.step = 4;
    }
  },
  data() {
    return {
      // 密码验证
      showPassword: false,
      password: "",
      key: 0,
      step: 1,
      password: "",
      form: {
        // 昵称
        name: "",
        // 终端人数
        num: 1,
        // 人员列表
        personList: [],
        playerList: [],
        // 游戏总人数
        playersNum: 0,
        isPass: false,
      },
      gameInfo: {},
      userInfo: {},
      // 1单人游戏、2多人游戏、3家庭团体游戏
      gameType: 1,
      ws: null,
      inviteNumber: "",
      // 当前是否是创建者
      isCreater: false,
    };
  },
  methods: {
    nextStep() {
      if (this.step == 1) {
        if (!this.form.name) {
          this.$toast("请输入昵称");
          return;
        }
        const data = {
          gameId: this.key,
          list: [
            {
              nickName: this.form.name,
              avatar: this.userInfo.avatar,
              userId: this.userInfo.uid,
              gameId: this.key,
            },
          ],
          password: this.form.password,
        };
        // 人数为1或者游戏类型为多人团体游戏
        if (this.gameInfo.playersNum == 1 || this.gameInfo.gameType == 2) {
          this.createPlayer(data).then((res) => {
            // 表示游戏已经开始，中途进入
            if (this.$route.query.gameStart == 1) {
              // 直接跳转到开始游戏
              this.$router.push({
                path: "/game/start",
                query: {
                  gameId: this.key,
                },
              });
              return;
            }
            this.step += 2;
          });
        } else {
          this.step++;
        }
      } else if (this.step == 2) {
        if (!this.form.num) {
          this.$toast("请输入终端人数");
          return;
        }
        const personList = this.form.personList.map((item) => {
          return {
            nickName: item.nickName,
            playerType: item.playerType,
            avatar: this.userInfo.avatar,
            gameId: this.key,
            userId: this.userInfo.uid,
          };
        });
        const data = {
          gameId: this.key,
          list: [...personList],
          password: this.form.password,
        };

        this.createPlayer(data).then((res) => {
          this.step++;
        });
      } else if (this.step == 3) {
        // 表示游戏已经开始，中途进入
        if (this.$route.query.gameStart == 1) {
          // 直接跳转到开始游戏
          this.$router.push({
            path: "/game/start",
            query: {
              gameId: this.key,
            },
          });
          return;
        }
        this.step++;
      } else if (this.step == 4) {
        this.$dialog.confirm({
          mes: "请确认所有参与者已到位",
          opts: () => {
            this.enterGame();
          },
        });
      }
    },
    createPlayer(data) {
      return new Promise((resolve, reject) => {
        createPlayer(data)
          .then((res) => {
            if (res.success) {
              this.$dialog.message("创建成功");
              resolve(res.data);
            } else {
              this.$dialog.message(res.msg);
              reject(res.data);
            }
          })
          .catch((err) => {
            this.$dialog.message(err.msg);
            reject();
          });
      });
    },
    wsMessage(data) {
      const dataJson = data;
      this.playersNum = dataJson.playersNum;
      if (dataJson == "pong") {
        console.log("心跳");
        return;
      }

      // 当前角色为用户
      if (!this.isCreater) {
        // 处理用户
        if (this.step == 3) {
          // 教练开始游戏，用户进入游戏
          if (dataJson.type == 1 && dataJson.gameStatus == 1) {
            const data = {
              gameId: dataJson.gameId,
            };
            this.$router.push({
              path: "/game/start",
              query: data,
            });
          }
        }

        // 结束游戏，退出
        if (dataJson.gameStatus == 2) {
          this.$dialog.message("游戏结束");
          this.$router.push({
            path: "/game/my",
          });
        }
      }
      // 当前角色为教练
      if (this.isCreater) {
        if (dataJson.type == 2) {
          this.getGamePlayerList();
        }
      }
    },
    // 获取当前游戏信息
    getGameInfo() {
      // // const gameUrl = "https://m.lcwlit.com/?code=gcfPFia0";
      // const gameId = this.$route.query.gameId;
      // // 获取当前本地访问域名
      // getRoundConfig({ gameId })
      //   .then((res) => {
      //     if (res.success) {
      //       this.isCreater = res.data.coachId == this.userInfo.uid;
      //       console.log("isCreater", this.isCreater, res.data.coachId, this.userInfo.uid);
      //       // 只有用户才显示密码
      //       if (!this.isCreater) {
      //         this.form.isPass = res.data.isPass;
      //       }

      //       // // this.showPassword = true;
      //       this.gameInfo = res.data;
      //       this.form.playersNum = res.data.playersNum;

      //       // 如果当前游戏为家庭游戏,并且是用户，直接跳转到step2
      //       if (res.data.gameType == 3 && !this.isCreater) {
      //         this.step = 2;
      //       }

      //       // this.form.password = res.data.password;
      //       // 检测当前用户是否已创建
      //       if (!this.isCreater) {
      //         if (res.data.isCreate == 1) {
      //           this.step = 3;
      //         }
      //       }
      //     } else {
      //       this.$dialog.confirm({
      //         title: "温馨提示",
      //         mes: "请检查您的身份，如使用教练账号登录，请退出后重新使用用户账号登录",
      //         opts: [
      //           {
      //             txt: "取消",
      //             color: false,
      //             callback: () => {
      //               this.$router.push({
      //                 path: "/game/my",
      //               });
      //             },
      //           },
      //           {
      //             txt: "确定",
      //             color: true,
      //             callback: () => {
      //               this.$router.push({
      //                 path: "/game/my",
      //               });
      //             },
      //           },
      //         ],
      //       });
      //     }
      //   })
      //   .catch(() => {
      //     this.$dialog.confirm({
      //       title: "温馨提示",
      //       mes: "请检查您的身份，如使用教练账号登录，请退出后重新使用用户账号登录",
      //       opts: [
      //         {
      //           txt: "取消",
      //           color: false,
      //           callback: () => {
      //             this.$router.push({
      //               path: "/game/my",
      //             });
      //           },
      //         },
      //         {
      //           txt: "确定",
      //           color: true,
      //           callback: () => {
      //             this.$router.push({
      //               path: "/game/my",
      //             });
      //           },
      //         },
      //       ],
      //     });
      //   });
      return new Promise((resolve, reject) => {
        const gameId = this.$route.query.gameId;
        // 获取当前本地访问域名
        getRoundConfig({ gameId })
          .then((res) => {
            if (res.success) {
              this.isCreater = res.data.coachId == this.userInfo.uid;
              console.log(
                "isCreater",
                this.isCreater,
                res.data.coachId,
                this.userInfo.uid
              );
              // 只有用户才显示密码
              if (!this.isCreater) {
                this.form.isPass = res.data.isPass;
              }

              // // this.showPassword = true;
              this.gameInfo = res.data;
              this.form.playersNum = res.data.playersNum;

              // 如果当前游戏为家庭游戏,并且是用户，直接跳转到step2
              if (res.data.gameType == 3 && !this.isCreater) {
                this.step = 2;
              }

              // this.form.password = res.data.password;
              // 检测当前用户是否已创建
              if (!this.isCreater) {
                if (res.data.isCreate == 1) {
                  this.step = 3;
                }
              }
              resolve();
            } else {
              this.$dialog.confirm({
                title: "温馨提示",
                mes: "请检查您的身份，如使用教练账号登录，请退出后重新使用用户账号登录",
                opts: [
                  {
                    txt: "取消",
                    color: false,
                    callback: () => {
                      this.$router.push({ path: "/game/my" });

                      reject();
                    },
                  },
                  {
                    txt: "确定",
                    color: true,
                    callback: () => {
                      this.$router.push({ path: "/game/my" });
                      reject();
                    },
                  },
                ],
              });
            }
          })
          .catch(() => {
            this.$dialog.confirm({
              title: "温馨提示",
              mes: "请检查您的身份，如使用教练账号登录，请退出后重新使用用户账号登录",
              opts: [
                {
                  txt: "取消",
                  color: false,
                  callback: () => {
                    this.$router.push({ path: "/game/my" });
                    reject();
                  },
                },
                {
                  txt: "确定",
                  color: true,
                  callback: () => {
                    this.$router.push({ path: "/game/my" });
                    reject();
                  },
                },
              ],
            });
          });
      });
    },
    getGamePlayerList() {
      getPlayerList({ gameId: this.key }).then((res) => {
        if (res.success) {
          // this.form.personList = res.data;
          this.form.playerList = res.data;
        }
      });
    },
    // 教练点击进入游戏
    enterGame() {
      this.$dialog.message("正在进入游戏，请稍后");
      modifyGameStatus({ gameId: this.key, status: 1 })
        .then((res) => {
          this.$router.push({
            path: "/game/discus",
            query: {
              gameId: this.key,
            },
          });
          this.$dialog.message("游戏开始");
        })
        .catch((err) => {
          this.$dialog.message(err.msg);
        });
    },
    // 强制结束游戏
    exitGame() {
      modifyGameStatus({ gameId: this.key, status: 2 })
        .then((res) => {
          this.$dialog.message("游戏已结束");
          this.$router.push({
            path: "/game/my",
          });
        })
        .catch((err) => {
          this.$dialog.message(err.msg);
        });
    },
    // 用户退出游戏
    userExitGame() {
      exitGame(this.key)
        .then((res) => {
          this.$dialog.message("退出成功");
          this.$router.push({
            path: "/game/my",
          });
        })
        .catch((err) => {
          this.$dialog.message(err.msg);
        });
    },
    // 密码验证
    confirmPassword() {
      if (this.password) {
        // this.form.password = this.password;
        this.showPassword = false;
      } else {
        Notify("请输入当前游戏密码，如不知道密码，请联系教练询问");
      }
    },

    returnLink() {
      if (!this.isCreater) {
        if (this.step > 1) {
          this.step--;
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    createSocket() {
      // this.requstWs(this.key, this.userInfo.uid);
      this.ws = new ws({
        url: `/game/${this.key}/${this.userInfo.uid}`,
        //心跳时间（单位:ms）
        heartBeat: 5000,
        //发送心跳信息（支持json传入）(这个一般内容不重要，除非后端变态)
        heartMsg: {
          roomId: this.key,
          userId: this.userInfo.uid,
          heartbeat: "ping",
        },
        //开起重连
        reconnect: true,
        //重连间隔时间（单位:ms）
        reconnectTime: 5000,
        //重连次数
        reconnectTimes: 10,
      });

      this.ws //接收信息
        .onmessage((data) => {
          console.log(data);
          if (data == "pong") {
            return;
          }
          this.wsMessage(JSON.parse(data));
        });
      this.ws.onerror((err) => {
        console.log("err", err);
      });
      console.log(
        {
          roomId: this.key,
          userId: this.userInfo.uid,
          heartbeat: "ping",
        },
        "心跳"
      );
      //关闭事件
      // this.ws.onclose((event) => {
      //   console.log(event);
      // });

      //开启事件
      // this.ws.onopen((event) => {
      //   console.log("开启");
      //   this.ws.send({
      //     roomId: this.key,
      //     userId: this.userInfo.uid,
      //     heartbeat: "ping",
      //   });
      // });
    },
    // 复制链接
    copyLink() {
      // 原生复制
      const input = document.createElement("input");
      input.setAttribute("readonly", "readonly");
      if (this.gameInfo.password) {
        input.setAttribute(
          "value",
          `游戏链接：${this.gameInfo.gameUrl}  游戏密码：${this.gameInfo.password}`
        );
      } else {
        input.setAttribute("value", this.gameInfo.gameUrl);
      }
      input.style.position = "absolute";
      input.style.left = "-9999px";
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, 9999);
      if (document.execCommand("copy")) {
        document.execCommand("copy");
      }
      this.$dialog.message("复制成功");
    },
    inviteHandle() {
      this.$dialog.confirm({
        mes: "确认邀请该玩家？",
        opts: () => {
          inviteMember({ gameId: this.key, phone: this.inviteNumber })
            .then((res) => {
              if (res.success) {
                this.$dialog.message("邀请成功");
              } else {
                this.$dialog.message(res.msg);
              }
            })
            .catch((err) => {
              this.$dialog.message(err.msg);
            });
        },
      });
    },
  },
  watch: {
    step: function (val) {
      if (val == 4 || val == 3) {
        console.log("创建socket");
        this.$nextTick(() => {
          this.createSocket();
        });
      }
    },
  },
  // 断开链接
  beforeDestroy() {
    this.ws.close();
    this.ws.ws.close();
    this.ws = null;
    console.log("销毁ws");
  },
};
</script>

<style lang="scss" scoped>
.choose {
  position: relative;
  display: flex;
  flex-direction: column;
  // align-items: center;
  justify-content: space-around;
  height: 100vh;
  padding: 0 1rem;
  background: url(~@/assets/game/bg.png) 100% no-repeat;
  background-size: 100% 100%;

  .choose-avatar {
    // background: #fff;
    overflow: hidden;
    display: flex;
    justify-content: center;
    // margin: 1rem 0;
    .choose-avatar-img {
      width: 1.8rem;
      height: 1.8rem;
      border-radius: 0.1rem;
    }
  }
  .choose-step {
  }

  .choose-btn {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.2rem;
    ::v-deep .nf-button {
      margin: 0 0.1rem;
    }
  }
}

::v-deep .van-nav-bar {
  background-color: rgb(172, 185, 233) !important;
}
</style>

<style>
.van-grid-item__content {
  background-color: inherit !important;
}
</style>
